import { FunctionComponent, useContext } from 'react';
import Toast from './components/Toast';
import { ToastContext } from './ToastContext';

const Toaster: FunctionComponent = () => {
    const { removeToast, toasts } = useContext(ToastContext)
    
    return (
        <div className="custom-toaster">
            { toasts.map((toast) => (
                <Toast key={toast.id} {...toast} removeToast={removeToast} />
            ))}
        </div>
    )
}

export default Toaster
